module.exports = __webpack_public_path__ + "img/orderAnalyModel3.46b69ad5.png";